import axios from 'axios'
import {toData} from "./util";

export function getBySubsidiaryId(id): Promise {
  return axios.get(`/api/idp/subsidiary/${id}`).then(toData)
}

export function getBySubsidiary(id): Promise {
  return axios.get(`/api/idp/subsidiary-by-id/${id}`).then(toData)
}
